export function pageTop(pageTopButtonEl, hide) {
  const $pageTopButton = $(pageTopButtonEl);
  if (hide) {
    $pageTopButton.hide();
    $(window).scroll(function () {
      const $scrollTop = $(this).scrollTop();
      if ($scrollTop) {
        if ($scrollTop > 500) {
          $pageTopButton.fadeIn();
        } else {
          $pageTopButton.fadeOut();
        }
      }
    });
  }
  $pageTopButton.click(function () {
    $("body, html").animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });
  // $pageTopButton.hide();
  $(window).on("scroll", function () {
    let scrollHeight = $(document).height();
    let scrollPosition = $(window).height() + $(window).scrollTop();
    let footHeight = $("footer").innerHeight();
    if (scrollHeight - scrollPosition <= footHeight) {
      // ページトップボタンがフッター手前に来たらpositionとfixedからabsoluteに変更
      $pageTopButton.css({
        position: "absolute",
        bottom: footHeight,
      });
    } else {
      $pageTopButton.css({
        position: "fixed",
        bottom: "0",
      });
    }
  });
}
